import MascotEvalImg from "../../assets/images/neumetric-mascot-eval.png";
import MascotEvalImg2 from "../../assets/images/neumetric-mascot-eval2.png";
import MascotEvalImg3 from "../../assets/images/neumetric-mascot-eval3.png";

export const MascotEval = (props) => {
  return <img src={MascotEvalImg} {...props} />;
};
export const MascotEval2 = (props) => {
  return <img src={MascotEvalImg2} {...props} />;
};
export const MascotEval3 = (props) => {
  return <img src={MascotEvalImg3} {...props} />;
};
